module.exports = __webpack_public_path__ + "img/borussia.5a225f86.png";